<template>
	<div class="detailBody">
		
		<a-breadcrumb>
			<a-breadcrumb-item>订单管理</a-breadcrumb-item>
		    <a-breadcrumb-item>订单列表</a-breadcrumb-item>
		    <a-breadcrumb-item>订单详情</a-breadcrumb-item>
		</a-breadcrumb>
		
		<div class="borderBox">
			<a-steps style="padding: 1%;" :current="orderStatus" status="error">
				<a-step title="提交订单" description="用户提交订单." />
				<a-step title="支付订单" description="用户支付订单." />
				<a-step title="平台发货" description="商家发货订单." />
				<a-step title="确认收货" description="用户确认收货." />
				<a-step title="完成评价	" description="用户完成评价." />
			</a-steps>
		</div>
		<a-card class="orderCard" :headStyle="{color:'red',background:'#F2F6FC',padding: '20px 0px 20px 20px'}">
			<span slot="title"> 
				<a-icon :style="{ fontSize: '25px'}" type="exclamation-circle" /> 
				当前订单状态: 
				<span>
				  <span v-if="orderStatus == 1" class="orderStatusTag" color='red'>待付款</span>
				  <span v-if="orderStatus == 2" class="orderStatusTag" color='#2db7f5'>待发货</span>
				  <span v-if="orderStatus == 3" class="orderStatusTag" color='purple'>待收货</span>
				  <span v-if="orderStatus == 4" class="orderStatusTag" color='cyan'>待评价</span>
				  <span v-if="orderStatus == 5" class="orderStatusTag" color='green'>交易成功</span>
				  <span v-if="orderStatus == 6" class="orderStatusTag" color='#ff5500'>交易关闭</span>
				  
				</span>
			</span>
			<p style="fontSize: 16px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
				<a-icon type="book" /> 基本信息
			</p>
			<a-table class="ant-table-thead" :pagination="false" :columns="basicInfocolumnOne" :dataSource="orderDetail" bordered>
				<span slot="payStatus" slot-scope="text">
					<span v-if="text == 0" >未支付</span>
					<span v-if="text == 1" ><a-badge status="success" />支付成功</span>
					<span v-if="text == 2" >已退款</span>
				</span>
			</a-table>
			<a-table :pagination="false" :columns="basicInfocolumnTwo" :dataSource="orderDetail" bordered>
				<template slot="shippingCompName" slot-scope="text">
					<span v-if="text == null" >暂无</span>
					<span v-else >{{text}}</span>
				</template>
				<template slot="shippingSn" slot-scope="text">
					<span v-if="text == null" >暂无</span>
					<span v-else >{{text}}</span>
				</template>
				<template slot="autoVerifyTime" slot-scope="text">
					<span>{{text}}天</span>
				</template>
				<template slot="createTime" slot-scope="text">
					<span v-if="text == undefined || text == null">暂无</span>
					<span v-else >{{text}}</span>
				</template>
			</a-table>
			<br />
			<p style="fontSize: 16px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
				<a-icon type="book" /> 收货人信息
			</p>
			<a-table :pagination="false" :columns="consigneeInfocolumn" :dataSource="orderDetail" bordered>
				<template slot="name" slot-scope="text">
					<a>{{ text }}</a>
				</template>
				<template slot="address" slot-scope="text, record">
					<span>{{record.areaStr}}{{record.address}}</span>
				</template>
				<template slot="remark" slot-scope="text">
					<span v-if="text != undefined && text != ''">{{text}}</span>
					<span v-else style="color: #aaa0a0;">暂无订单备注</span>
				</template>
			</a-table>
			<br />
			<p style="fontSize: 16px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
				<a-icon type="book" /> 商品信息
			</p>
			<a-table :pagination="false" :columns="productInfocolumn" :dataSource="productDetail" bordered>
				<template slot="productPic" slot-scope="text">
					<img style="width: 100px;" :src="text" alt="">
				</template>
			</a-table>
			<br />
			<p style="fontSize: 16px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
				<a-icon type="book" /> 费用信息
			</p>
			<a-table class="ant-table-thead" :pagination="false" :columns="costInfocolumnOne" :dataSource="orderDetail" bordered>
				<template slot="coupon" slot-scope="text">
					<span>-￥0</span>
				</template>
				<template slot="districtMoney" slot-scope="text">
					<span>-￥{{text}}</span>
				</template>
				<template slot="payOrderMoney" slot-scope="text, record">
					<a>{{ record.sumProductPrice }}</a>
				</template>
			</a-table>
			<!-- <a-table :pagination="false" :columns="costInfocolumnTwo" :dataSource="orderDetail" bordered>
				<template slot="payOrderMoney" slot-scope="text, record">
					<a>{{ record.sumProductPrice }}</a>
				</template>
				<template slot="activityDiscounts" slot-scope="text, record">
					<span>￥0</span>
				</template>
			</a-table> -->
			<br />
			<!-- <p style="fontSize: 16px;color: rgba(0, 0, 0, 0.85); marginBottom: 16px;fontWeight: 500">
				<a-icon type="book" /> 操作信息
			</p>
			<a-table class="ant-table-thead" :pagination="false" :columns="userInfocolumn" :dataSource="user" bordered>
				
			</a-table> -->
		</a-card>
	</div>
</template>

<script>
	import api from '../../../api/Api.js';
export default {
	data() {
		return {
			basicInfocolumnOne,
			basicInfocolumnTwo,
			consigneeInfocolumn,
			productInfocolumn,
			costInfocolumnOne,
			costInfocolumnTwo,
			userInfocolumn,
			orderDetail:[],
			orderId : this.$route.query.id,
			orderStatus:1,
			productDetail:[],
			user:[]
		};
	},
	mounted() {
		this.getOrderDetailInfo();
	},
	methods: {
		getOrderDetailInfo(){
			const that = this;
			let url = 'api/store/v1/admin/order/getOrderDetail';
			let parm = {
				orderId: this.orderId
			};
			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					const order = res.data.data;
					that.orderStatus = order.orderStatus;
					order.key = '1';
					order.orderMoney = this.formatMoney(order.orderMoney);
					order.sumProductPrice = this.formatMoney(order.sumProductPrice);
					order.sumProductBazaarPrice = this.formatMoney(order.sumProductBazaarPrice);
					order.districtMoney = this.formatMoney(order.districtMoney);
					order.shippingMoney = this.formatMoney(order.shippingMoney);
					order.productInfoList.forEach((item, index, array) => {
						item.key = index+1;
						item.price = this.formatMoney(item.price);
						item.bazaarPrice = this.formatMoney(item.bazaarPrice);
						item.sumPrice = this.formatMoney(item.sumPrice);
						item.sumBazaarPrice = this.formatMoney(item.sumBazaarPrice);
					})
					this.productDetail = order.productInfoList;
					this.orderDetail.push(order);
					
					console.log(this.orderDetail)
				} else if (res.data.status == 501) {
					this.$message.error(res.message);
				} else {
					this.$message.error(res.message);
				}
			});
		},
		formatMoney(money){
			money += '';
			var arr = money.split('');
			var money = '';
			for (var i = 0; i < arr.length; i++) {
				money += arr[i];
				if (i == arr.length - 3) {
					money += '.';
				}
			}
			return "￥"+money;
		}
	}
};
	const basicInfocolumnOne = [
	  {
	    title: '订单编号',
		align:'center',
		width:'25%',
	    dataIndex: 'orderSn'
	  },
	  {
	    title: '用户账号',
		align:'center',
		width:'25%',
	    dataIndex: 'phone',
	  },
	  {
	    title: '支付状态',
	    dataIndex: 'payStatus',
		align:'center',
	    key: 'payStatus',
	  	scopedSlots: { customRender: 'payStatus' }
	  },
	  {
	    title: '订单类型',
		align:'center',
		width:'25%',
	    dataIndex: 'orderType',
	  },
	];
	
	const basicInfocolumnTwo = [
	  {
	    title: '配送方式',
		align:'center',
		width:'25%',
	    dataIndex: 'shippingCompName',
	    scopedSlots: { customRender: 'shippingCompName' },
	  },
	  {
	    title: '物流单号',
		align:'center',
		width:'25%',
	    dataIndex: 'shippingSn',
		scopedSlots: { customRender: 'shippingSn' },
	  },
	  {
	    title: '自动确认收货时间',
		align:'center',
		width:'25%',
	    dataIndex: 'autoVerifyTime',
		scopedSlots: { customRender: 'autoVerifyTime' },
	  },
	  {
	    title: '提交时间',
		align:'center',
		width:'25%',
	    dataIndex: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	  },
	];
	
	
	const consigneeInfocolumn = [
	  {
	    title: '收货人',
		align:'center',
		width:'25%',
	    dataIndex: 'nickName',
	  },
	  {
	    title: '手机号码',
		align:'center',
		width:'25%',
	    dataIndex: 'tel',
	  },
	  {
	    title: '收货地址',
		align:'center',
		width:'25%',
	    scopedSlots: { customRender: 'address' },
	  },
	  {
	    title: '订单备注',
		align:'center',
		width:'25%',
	    dataIndex: 'remark',
		scopedSlots: { customRender: 'remark' },
	  },
	];
	
	const productInfocolumn = [
	  {
	    title: '商品图片',
		align:'center',
		width:'15%',
	    dataIndex: 'spUrl',
	    scopedSlots: { customRender: 'productPic' },
	  },
	  {
	    title: '商品名称',
		align:'center',
		width:'45%',
	    dataIndex: 'productName',
	  },
	  {
	    title: '价格',
		align:'center',
		width:'10%',
	    dataIndex: 'bazaarPrice',
	  },
	  {
	    title: '属性/规格',
		align:'center',
		width:'10%',
	    dataIndex: 'specification',
	  },
	  {
	    title: '数量',
		align:'center',
		width:'10%',
	    dataIndex: 'productCnt',
	  },
	  {
	    title: '小计',
		align:'center',
		width:'10%',
	    dataIndex: 'sumBazaarPrice',
	  },
	];
	
	const costInfocolumnOne = [
		{
			title: '订单总金额',
			align:'center',
			width:'25%',
			dataIndex: 'sumProductBazaarPrice'
		 },
		 {
			title: '运费',
			align:'center',
			width:'25%',
			dataIndex: 'shippingMoney',
		 },
		 {
			title: '会员折扣',
			align:'center',
			width:'25%',
			dataIndex: 'districtMoney',
		 },
		 {
			title: '实付款金额',
			align:'center',
			width:'25%',
			scopedSlots: { customRender: 'payOrderMoney' },
		 }
	];
	
	const costInfocolumnTwo = [
		{
			title: '活动优惠',
			align:'center',
			width:'25%',
			dataIndex: 'activityDiscounts',
			scopedSlots: { customRender: 'activityDiscounts' },
		 },
		 {
			title: '折扣金额',
			align:'center',
			width:'25%',
			dataIndex: 'districtMoney',
			scopedSlots: { customRender: 'districtMoney' },
		 },
		 {
			title: '订单总金额',
			align:'center',
			width:'25%',
			dataIndex: 'sumProductPrice',
		 },
		 {
			title: '实付款金额',
			align:'center',
			width:'25%',
			scopedSlots: { customRender: 'payOrderMoney' },
		 }
	];
	
	const userInfocolumn = [
		{
			title: '操作者',
			align:'center',
			width:'15%',
			dataIndex: 'orderSn1',
			scopedSlots: { customRender: 'name' },
		 },
		 {
			title: '操作时间',
			align:'center',
			width:'20%',
			dataIndex: 'money1',
		 },
		 {
			title: '订单状态',
			align:'center',
			width:'15%',
			dataIndex: 'address1',
		 },
		 {
			title: '付款状态',
			align:'center',
			width:'15%',
			dataIndex: 'orderType5',
		 },
		 {
			title: '发货状态',
			align:'center',
			width:'15%',
			dataIndex: 'orderType1',
		 },
		 {
			title: '备注',
			align:'center',
			width:'40%',
			dataIndex: 'orderType2',
		 }
	];
	
</script>

<style scoped>
	
	.detailBody{
		padding-left: 16%;
		padding-right: 16%;
		padding-top: 5%;
	}
	
	.borderBox{
		padding-left: 10%;
		padding-right: 10%;
	}
	
	.orderCard{
		margin-top: 40px;
		margin-bottom: 40px;
	}
	
	th.column-money,
	td.column-money {
	  text-align: right !important;
	}
	.ant-table-thead > tr > th{
		background: #F2F6FC;
	}
	.orderStatusTag{
		font-size: 18px;
	}
	
	
</style>
